export function getKidpreneursAcademyLink(template?: string): string {
    return template || '<a target="_blank" href="https://kidpreneurs.academy">Kidpreneurs.academy</a>';
}

export function getPrimaryKidpreneursAcademyLink(): string {
    return `<span class="underline text-primary">${getKidpreneursAcademyLink()}</span>`;
}
